import React from 'react';
import {Box, Typography} from '@emburse/ui-core';
import {useTranslation} from 'react-i18next';

export interface CustomFieldOptionProps {
    label: string;
    fieldType?: string;
    recordType?: string;
    accountType?: string;
    applyTo?: string;
    scriptId?: string;
    fieldLevel?: string;
}

export const CustomFieldOption = ({label, recordType, fieldType, applyTo, scriptId, fieldLevel, accountType}: CustomFieldOptionProps) => {
    const {t} = useTranslation();
    return (
        <Box sx={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
            <Box>{label}</Box>
            <Box className="hover-option-id" data-qa="hover-option-id" sx={{display: 'none', flexDirection: 'column', whiteSpace: 'nowrap'}}>
                {recordType !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('recordType')}: {recordType}</Typography>
                )}
                {accountType !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('accountType')}: {accountType}</Typography>
                )}
                {fieldType !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('fieldType')}: {fieldType}</Typography>
                )}
                {applyTo !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('applyTo')}: {applyTo}</Typography>
                )}
                {scriptId !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('scriptId')}: {scriptId}</Typography>
                )}
                {fieldLevel !== undefined && (
                    <Typography variant="caption" color="textSecondary">{t('fieldLevel')}: {fieldLevel}</Typography>
                )}
            </Box>
        </Box>
    );
};